import React from "react";
const Calculator = () => {
    const [calc, setCalc] = React.useState({
        current: "0",
        total: "0",
        isInitial: true,
        preOp: ""
    });

    function handleNumber(value) {
        let newValue = value;
        if (!calc.isInitial) {
            newValue = calc.current + value
        }
        setCalc({
            current: newValue,
            total: calc.total,
            isInitial: false,
            preOp: calc.preOp
        });
    }
    function doCalculation() {
        let total = parseInt(calc.total)
        switch (calc.preOp) {
            case "+":
                total += parseInt(calc.current)
                break;
            case "-":
                total -= parseInt(calc.current)
                break;
            case "*":
                total *= parseInt(calc.current)
                break;
            case "/":
                total /= parseInt(calc.current)
                break;
            default:
                total = parseInt(calc.current)
        }
        return total;
    }
    function handleOperator(value) {
        const total = doCalculation();
        setCalc({ current: total.toString(), total: total.toString(), isInitial: true, preOp: value })
    }
    function handleClear() {
        setCalc({
            current: "0",
            total: "0",
            isInitial: true,
            preOp: ""
        })
    }
    return (
        <>
            <div className="calc-container">
                <div className="display">{calc.current}</div>
                <CalcButtons value="7" onClick={handleNumber} />
                <CalcButtons value="8" onClick={handleNumber} />
                <CalcButtons value="9" onClick={handleNumber} />
                <CalcButtons className="operator" onClick={handleOperator} value="/" />
                <CalcButtons value="4" onClick={handleNumber} />
                <CalcButtons value="5" onClick={handleNumber} />
                <CalcButtons value="6" onClick={handleNumber} />
                <CalcButtons className="operator" onClick={handleOperator} value="*" />
                <CalcButtons value="3" onClick={handleNumber} />
                <CalcButtons value="2" onClick={handleNumber} />
                <CalcButtons value="1" onClick={handleNumber} />
                <CalcButtons className="operator" onClick={handleOperator} value="-" />
                <CalcButtons value="C" onClick={handleClear} />
                <CalcButtons value="0" onClick={handleNumber} />
                <CalcButtons value="=" onClick={handleOperator} />
                <CalcButtons className="operator" onClick={handleOperator} value="+" />
            </div>
        </>
    )
}
function CalcButtons(props) {
    const handleClick = () => {
        if (props.onClick) {
            props.onClick(props.value);
        }
    };
    return <button onClick={handleClick} className={props.className}>{props.value}</button>;
}
export default Calculator;
/* <div className="container">Hello {props.name}, I heard you were {props.age} years old.</div> */